import {categoryValuesToLabel} from './meili/search-index-values-to-labels.mjs';

export const groupSearchResults = (items) => {
	let groupedItems = processSearchResultsByCollectionsV2(items);

  const numberOfCollectionsWithSingleItem = groupedItems?.filter(collection => collection?.items?.length === 1)?.length;
  const moreThanHalfCollectionsHaveSingleItem = numberOfCollectionsWithSingleItem > groupedItems?.length / 2;

	if(moreThanHalfCollectionsHaveSingleItem) {
		groupedItems = processSearchResultsByCategory(items);
	}

	return groupedItems
}

export const processSearchResultsByCollectionsV2 = (items) => {
	const groupedItems = {};
	const otherCollectionId = '-1';
	const highestTotalTurn30Map = new Map();
	const keywordFrequencyMap = new Map();

	if (!groupedItems[otherCollectionId]) {
		groupedItems[otherCollectionId] = {
			id: otherCollectionId,
			title: 'Other',
			highestTotalTurn30: 0,
			category: 'other',
			items: [],
		};
	}

	for (const item of items) {
		const collectionId = item?.collectionId?.toString();
		const collectionTitle = item?.collectionTitle;
		const collectionHandle = item?.collectionHandle;

		if (!collectionId) {
			groupedItems[otherCollectionId].items.push(item);
			continue;
		}

		if (!groupedItems[collectionId]) {
			groupedItems[collectionId] = {
				id: collectionId,
				title: collectionTitle,
				handle: collectionHandle,
				category: item?.category,
				highestTotalTurn30: 0,
				items: [],
			};
		}

		const variantSkus = item?.variantSkus;
		const variantSkusContainCoilConfig = variantSkus?.some(
			(sku) => sku?.includes('D1') || sku?.includes('D2') || sku?.includes('D4')
		);
		let displaySku = item?.sku;
		if (variantSkus?.length > 1 && variantSkusContainCoilConfig) {
			const justCoilConfigs = variantSkus?.map((sku) => sku?.split(' ').pop());
			displaySku = `${displaySku} (${justCoilConfigs.join('/')})`;
		}

		item.displaySku = displaySku;

		groupedItems[collectionId].items.push(item);

		const highestTotalTurn30 = Math.max(...groupedItems[collectionId].items.map((i) => i.totalTurn30));
		highestTotalTurn30Map.set(collectionId.toString(), highestTotalTurn30);
		groupedItems[collectionId].highestTotalTurn30 = highestTotalTurn30;

		for (const keyword of item.keywords) {
			const currentCount = keywordFrequencyMap.get(keyword) || 0;
			keywordFrequencyMap.set(keyword, currentCount + 1);
		}
	}

	if(groupedItems[otherCollectionId]?.items.length === 0) {
		delete groupedItems[otherCollectionId];
	}

	for (const collectionId in groupedItems) {
		const highestTotalTurn30 = highestTotalTurn30Map.get(collectionId);
		groupedItems[collectionId].items.sort((a, b) => b.totalTurn30 - a.totalTurn30);
		groupedItems[collectionId].items.forEach(item => {
			item.isBestSeller = item.totalTurn30 === highestTotalTurn30;
		});
	}

	let groupedItemsArray = Object.values(groupedItems);
	// console.log({groupedItemsArray});

	// First, sort by collection with highestTotalTurn30
	groupedItemsArray.sort((a, b) => {
		if(a.category === 'batteries') return -1;
		if(a.category === 'power-distribution-blocks') return 1;
		if(a.category === 'rca-interconnects') return 1;

		if (a.collectionId === otherCollectionId) return 1;
		if (b.collectionId === otherCollectionId) return -1;
		return b.highestTotalTurn30 - a.highestTotalTurn30;
	});

	// Then, group by category
	let groupedByCategory = {};
	groupedItemsArray.forEach(item => {
		if (!groupedByCategory[item.category]) {
			groupedByCategory[item.category] = [];
		}
		groupedByCategory[item.category].push(item);
	});

	let finalArray = [];
	for (let category in groupedByCategory) {
		finalArray.push(...groupedByCategory[category]);
	}

	return finalArray
}

export const processSearchResultsByCategory = (items) => {
	const groupedItems = {};
	const highestTotalTurn30Map = new Map();
	const keywordFrequencyMap = new Map();

	for (const item of items) {
		const category = item?.category;

		if (!groupedItems[category]) {
			groupedItems[category] = {
				category: category,
				title: categoryValuesToLabel[category],
				highestTotalTurn30: 0,
				items: [],
			};
		}

		const variantSkus = item?.variantSkus;
		const variantSkusContainCoilConfig = variantSkus?.some(
			(sku) => sku?.includes('D1') || sku?.includes('D2') || sku?.includes('D4')
		);
		let displaySku = item?.sku;
		if (variantSkus?.length > 1 && variantSkusContainCoilConfig) {
			const justCoilConfigs = variantSkus?.map((sku) => sku?.split(' ').pop());
			displaySku = `${displaySku} (${justCoilConfigs.join('/')})`;
		}

		item.displaySku = displaySku;

		groupedItems[category].items.push(item);

		const highestTotalTurn30 = Math.max(...groupedItems[category].items.map((i) => i.totalTurn30));
		highestTotalTurn30Map.set(category, highestTotalTurn30);
		groupedItems[category].highestTotalTurn30 = highestTotalTurn30;

		for (const keyword of item.keywords) {
			const currentCount = keywordFrequencyMap.get(keyword) || 0;
			keywordFrequencyMap.set(keyword, currentCount + 1);
		}
	}

	for (const category in groupedItems) {
		const highestTotalTurn30 = highestTotalTurn30Map.get(category);
		groupedItems[category].items.sort((a, b) => b.totalTurn30 - a.totalTurn30);
		groupedItems[category].items.forEach(item => {
			item.isBestSeller = item.totalTurn30 === highestTotalTurn30;
		});
	}

	let groupedItemsArray = Object.values(groupedItems);

	// Sort by highestTotalTurn30
	groupedItemsArray.sort((a, b) => {
		if(a.category === 'batteries') return -1;
		if(a.category === 'power-distribution-blocks') return 1;
		if(a.category === 'rca-interconnects') return 1;

		return b.highestTotalTurn30 - a.highestTotalTurn30;
	});

	return groupedItemsArray;
}
